import { ExamesSolicitadosQuery } from 'graphql/types.generated'
import { formatDate } from 'util/date/formatDate'

import { ExameQueryModel } from '../../../resultados-exames/model-resultadosExames'
import { ExameSolicitadoSelectModel, ResultadoExameAnexoFormModel } from '../../model-anexoArquivos'

export function convertResultadosExameToSelectModel(
  data: ExamesSolicitadosQuery,
  profissionalId: string
): ExameSolicitadoSelectModel[] {
  return (
    data?.resultadosExame?.content?.map((exameSemResultado) => {
      const lotacao = exameSemResultado.atendimentoProfissionalSolicitacao?.lotacao
      return {
        id: exameSemResultado.id,
        descricao: exameSemResultado.exame.descricao.capitalize(),
        codigo: exameSemResultado.exame.codigo,
        dataSolicitacao: formatDate(exameSemResultado.dataSolicitacao),
        idProfissional: lotacao?.profissional?.id === profissionalId ? null : lotacao?.profissional?.id,
        nomeProfissional: lotacao?.profissional?.nome || '',
        idUnidadeSaude: lotacao?.unidadeSaude?.id || '',
        nomeUnidadeSaude: lotacao?.unidadeSaude?.nome || '',
        cbo: lotacao?.cbo?.nome || '',
      }
    }) || []
  )
}

export function convertToExameQueryModel(item: ResultadoExameAnexoFormModel): ExameQueryModel {
  return {
    id: item.id,
    codigo: item.codigo,
    descricao: item.descricao,
    procedimentoReferencia: {
      id: item.id,
      descricao: item.descricao,
      codigo: item.codigo,
    },
    idadeMaxima: null,
    idadeMinima: null,
  }
}
